// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"87983fa5","161":"cb5a2f44","453":"dbb66f8d","478":"859d62e5","529":"ece5d673"}[chunkId] + ".chunk.js";
};